import React from "react";
import type { ChatMessageListProps } from "../annotations/WhatsAppAnnotations";
import { t } from "components/CentralDataMangement/translation/Translation";
import { groupMessagesByDate } from "./helpers";
import DateGroup from "./DateGroup";

const ChatMessageList: React.FC<ChatMessageListProps> = ({ messages, loading }) => {
  const groupedMessages = groupMessagesByDate(messages);
  const dateKeys = Object.keys(groupedMessages);

  return (
    <>
      {dateKeys.length > 0 ? (
        dateKeys.map((dateKey) => (
          <DateGroup key={dateKey} dateKey={dateKey} messages={groupedMessages[dateKey]} />
        ))
      ) : !loading ? (
        <div className="text-center color-dark-pink marginTop2">
          {t(" No messages found")}
        </div>
      ) : null}
    </>
  );
};

export default ChatMessageList;
